









































import { Vue, Component } from 'vue-property-decorator';
import { Form } from '@ss/mtd-vue';
import * as api from '@/api';
import { getStringLength } from '@/utils/tool';
import { triggerTimeOptions } from '@/config/map.conf';
import TriggerConditions from './trigger/trigger-conditions.vue';
import TriggerActions from './trigger/trigger-actions.vue';
/**
 * 美维工单 迁移页面
 *
 * @author liyuyao
 * @date 07/09/2019
 */
@Component({
    components: {
        TriggerConditions,
        TriggerActions
    }
})
export default class TriggerEdit extends Vue {
    submitSingle: number = 0;

    btnLoading: boolean = false;
    form: any = {
        name: '',
        triggerTime: 'BEFORE_TT'
    };
    triggerTimeOptions: any = triggerTimeOptions;
    // 对应conditionGroups字段
    conditionGroupDo: CommonTypes.conditionGroupDo[] = [];
    // 对应actions字段
    actionDO: CommonTypes.actionDoItem[] = [];
    // 对应itemLogic字段，标识条件组之间关系
    itemLogic: string = '';

    actionError: boolean = true;
    conditionError: boolean = true;

    rules: any = {
        name: [
            {
                validator: (_rule, value, callback) => {
                    if (!value) {
                        callback(new Error('请输入触发器标题'));
                    } else if (getStringLength(value) > 40) {
                        callback(new Error('标题不能超过40个字符'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ],
        triggerTime: [
            {
                validator: (_rule, value, callback) => {
                    if (!value) {
                        callback(new Error('请选择触发时间'));
                    } else {
                        callback();
                    }
                },
                trigger: 'change'
            }
        ]
    };
    mounted() {
        this.triggerId && this.getTriggerDetail();
    }
    cancelBack() {
        this.$mtd
            .confirm({
                title: '确定要离开吗？系统可能不会保存您所做的更改',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确定',
                onOk: () => {
                    this.$router
                        .push({
                            name: 'rg_trigger',
                            query: {
                                rgId: `${this.rgId}`,
                                cn: this.$route.query.cn
                            }
                        })
                        .catch(e => e);
                }
            })
            .catch(e => e);
    }
    submit() {
        this.submitSingle++;
        setTimeout(() => {
            this.formatSubmit();
        }, 0);
    }
    hasConditionError(error) {
        this.conditionError = error;
    }
    hasActionError(error) {
        this.actionError = error;
    }
    $refs: {
        form: Form;
    };
    async formatSubmit() {
        this.$refs.form
            .validate(async valid => {
                console.log(valid, this.conditionError, this.actionError);
                if (valid && !this.conditionError && !this.actionError) {
                    const submitForm: CommonTypes.triggerForm = {
                        name: this.form.name,
                        scene: 'RG',
                        sceneId: this.rgId,
                        active: false,
                        triggerTime: this.form.triggerTime,
                        conditionGroups: this.conditionGroupDo,
                        actions: this.actionDO,
                        itemLogic: this.itemLogic
                    };
                    if (this.triggerId) submitForm.id = this.triggerId;
                    const res = this.triggerId
                        ? await api.ruleApi.updateTrigger(this.triggerId, submitForm)
                        : await api.ruleApi.createTrigger(submitForm);
                    const { code } = res;
                    if (code === 200) {
                        this.$mtd.message.success(this.triggerId ? '触发器更新成功' : '触发器创建成功');
                        this.$router
                            .push({
                                name: 'rg_trigger',
                                query: {
                                    rgId: `${this.rgId}`,
                                    cn: this.$route.query.cn
                                }
                            })
                            .catch(e => e);
                    }
                }
            })
            .catch(e => e);
    }
    async getTriggerDetail() {
        const res = await api.ruleApi.getTriggerDetail(this.triggerId);
        const { code, data } = res;
        if (code === 200) {
            this.form.name = data.name;
            this.form.triggerTime = data.triggerTime;
            this.actionDO = data.actions;
            this.conditionGroupDo = data.conditionGroups;
            this.itemLogic = data.itemLogic;
        }
    }
    actionChange(action) {
        this.actionDO = action;
    }
    conditionChange(condition) {
        this.conditionGroupDo = condition.conditionGroups;
        this.itemLogic = condition.groupLogic;
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    get triggerId() {
        return parseInt(this.$route.query.id as string, 10);
    }
}
